import { Component, OnInit, ViewChild } from "@angular/core";
import * as FileSaver from "file-saver";
import { NgxSpinnerService } from "ngx-spinner";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { Condition } from "src/app/models/custom-types";
import { ActaDTO } from "src/app/models/dto/acta.dto";
import { FilterEvent } from "src/app/models/filter";
import { ListAction } from "src/app/models/list-actions.model";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { LayoutsService } from "src/app/services/layouts.service";
import { Filter } from "src/app/shared/classes/filter";
import { OperadoresService } from "../../workers/operadores/operadores.service";
import { ActasAdminService } from "./actas.service";
import { ActasAdminForm } from "./form/form.component";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import * as dayjs from "dayjs";
import Swal from "sweetalert2";

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  selector: "app-actas",
  templateUrl: "./actas.component.html",
  styleUrls: [],
})
export class ActasAdminComponent implements OnInit {
  columnId: string = "IdEmpresa";
  public columns: ListColumn[] = [
    {
      name: "Folio",
      property: "Folio",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Nombre",
      property: "Nombre",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Testigo 1",
      property: "Testigo1",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Testigo 2",
      property: "Testigo2",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Cargo",
      property: "CargoCaja",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Fecha",
      property: "FechaDeActaStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Acepto",
      property: "AceptadaRechazadaTest",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public actions: ListAction<ActaDTO>[] = [
    {
      desc: "Acepto firmar",
      action: "accept",
      visible: (m) => m.FechaAceptadaRechazada == null,
    },
    {
      desc: "Rechazo firmar",
      action: "reject",
      visible: (m) => m.FechaAceptadaRechazada == null,
    },
    {
      desc: "Ver",
      action: "update",
      visible: () => true,
    },
    {
      desc: "Imprimir",
      action: "down",
      visible: () => true,
    },
  ];

  filtro: string = "";
  realdata: any[];
  list: any[];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;

  @ViewChild(ActasAdminForm, { static: true })
  public formulario: ActasAdminForm;
  constructor(
    public service: ActasAdminService,
    public opeServ: OperadoresService,
    public layoutService: LayoutsService,
    public spinner: NgxSpinnerService,
    public alerts: AlertasSwalService,
  ) {}
  ngOnInit(): void {
    this.loadRecords();
    this.filter = new Filter<ActaDTO>(this.conditions, this.columns, true);
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData: ActaDTO[]) => {
        this.realdata = resultData.map((m) => {
          const AceptadaRechazadaTest = m.FechaAceptadaRechazada
            ? m.AceptadaRechazada
              ? "✅"
              : "❌"
            : "❓";

          const raw = m.FechaDeActa;

          const fechaDeActa = raw
            ? /[zZ]|([+-]\d{2}:\d{2})$/.test(raw.toString())
              ? dayjs.utc(raw).tz("America/Los_Angeles") // viene con zona → tratar como UTC
              : dayjs(raw).tz("America/Los_Angeles") // sin zona → tratar como local
            : null;

          return {
            ...m,
            AceptadaRechazadaTest,
            FechaDeActaStr: fechaDeActa
              ? fechaDeActa.format("DD/MM/YYYY hh:mm a")
              : "",
          };
        });
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
    this.service.getTrabajadores().subscribe(
      (resultData) => {
        this.list = resultData;
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  //#region Filter
  public filter: Filter<ActaDTO>;
  public conditions: Condition<ActaDTO> = {
    Nombre: (o, f) => o.Nombre.toLocaleLowerCase().indexOf(f) > -1,
    Testigo1: (o, f) => o.Testigo1.toLocaleLowerCase().indexOf(f) > -1,
    Testigo2: (o, f) => o.Testigo2.toLocaleLowerCase().indexOf(f) > -1,
    CargoCaja: (o, f) =>
      (o.CargoCaja ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Folio: (o, f) =>
      (o.Folio ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter

  actionstable(e: { action: string; row: any }) {
    if (e.action == "update") {
      this.formulario.setUpdate(e.row);
    } else if (e.action == "down") {
      this.downLoad(e.row.IdActaAdministrativa, e.row.Folio);
    } else if (e.action == "accept") {
      this.accept(e.row);
    } else if (e.action == "reject") {
      this.reject(e.row);
    }
  }

  saveForm(e: { mode: string; value: any; type: number }) {
    if (e.mode == "create") {
      if (e.type == 1) this.guardar(e.value);
      else this.guardarCombu(e.value);
    }
  }
  guardar(row: any) {
    this.service.add(row).subscribe(
      async (next) => {
        const countGood = await this.retryUploadPhotos(next.asm, row.files);
        const mensajeEvidencias = `Se guardaron ${countGood} evidencias de ${row.files.length} enviadas.`;
        this.alerts.correcta(
          "Acta administrativa creada",
          "Folio " + next.folio + " " + mensajeEvidencias,
        );
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }
  guardarCombu(row: any) {
    this.service.addCombu(row).subscribe(
      async (next) => {
        const countGood = await this.retryUploadPhotos(next.asm, row.files);
        const mensajeEvidencias = `Se guardaron ${countGood} evidencias de ${row.files.length} enviadas.`;
        this.alerts.correcta(
          "Acta administrativa creada",
          "Folio " + next.folio + " " + mensajeEvidencias,
        );
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }
  private async retryUploadPhotos(asm: string, files: any[]): Promise<number> {
    let countGood = 0;
    let filesToTry = files.slice();

    // eslint-disable-next-line no-constant-condition
    while (true) {
      const newFailed: any[] = [];
      for (const file of filesToTry) {
        try {
          await this.service.addPhoto(asm, file).toPromise();
          countGood++;
        } catch (error: any) {
          if (error.error.Message === "Fallo a guardar evidencia") {
            newFailed.push(file);
          }
        }
      }

      if (newFailed.length === 0) break;

      const imagesHtml = `
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:12px;">
        ${newFailed
          .map(
            (file) => `
          <div style="aspect-ratio:1;overflow:hidden;border-radius:6px;border:1px solid #e2e8f0;">
            <img src="${URL.createObjectURL(file)}"
              style="width:100%;height:100%;object-fit:cover;display:block;" />
          </div>
        `,
          )
          .join("")}
      </div>`;

      const result = await Swal.fire({
        title: "Evidencias fallidas",
        html: `Las siguientes evidencias fallaron al subir:<br>${imagesHtml}`,
        showCancelButton: true,
        confirmButtonText: "Reintentar",
        cancelButtonText: "Continuar",
      });

      if (!result.isConfirmed) break;
      filesToTry = newFailed;
    }

    return countGood;
  }

  downLoad(e, folio) {
    this.spinner.show();
    this.service.getPdf(e).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(
          response.body,
          contentType,
          "acta_administrativa_" + folio + ".pdf",
        );
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      },
    );
  }
  downLoadFile(data: any, contentType: string, filename: string) {
    let blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
    this.spinner.hide();
  }
  accept(row: ActaDTO) {
    this.service.accept(row.IdActaAdministrativa).subscribe(
      (next) => {
        this.alerts.correcta("Firmada", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  reject(row: ActaDTO) {
    this.service.reject(row.IdActaAdministrativa).subscribe(
      (next) => {
        this.alerts.correcta("Rechazada", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }
}
